var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427322558"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 292083",
    cx: 12.5,
    cy: 13,
    r: 11,
    fill: "url(#paint0_linear_744_836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292042",
    d: "M21.7211 19C19.7584 22.0102 16.3616 24 12.5 24C6.42487 24 1.5 19.0751 1.5 13C1.5 6.92487 6.42487 2 12.5 2C15.9159 2 18.9681 3.55699 20.9857 6",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427322471"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 292043",
    cx: 12.5,
    cy: 11.3333,
    r: 3.33333,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292044",
    d: "M7.5 18.4167C8 16 10.2179 14.6667 12.5 14.6667C14.7821 14.6667 17 16 17.5 18.4167",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 427322470"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 20.75,
    y1: 9.5,
    x2: 22.25,
    y2: 9.5,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    x1: 20.75,
    y1: 12.5,
    x2: 23.25,
    y2: 12.5,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 17",
    x1: 20.75,
    y1: 15.5,
    x2: 21.25,
    y2: 15.5,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_836",
    x1: 3.85714,
    y1: 2,
    x2: 23.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDarkActive);
export default __webpack_public_path__ + "static/media/profile-dark-active.4616ff1af2b4ee5f1c2da76e436897b2.svg";
export { ForwardRef as ReactComponent };